import React from "react";
import { Row, Col, Typography } from "antd";

const { Title } = Typography;

const TableHeader = ({ left, right, equal, title, titleClass }) => (
  <Row type="flex" align="middle" justify="space-between" gutter={[0, 100]}>
    <Col span={equal ? 8 : 6}>{left}</Col>
    <Col span={equal ? 8 : 12}>
      <Title className={`center ${titleClass || ""}`}>{title}</Title>
    </Col>
    <Col span={equal ? 8 : 6} className="right">
      {right}
    </Col>
  </Row>
);

export default TableHeader;
